import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import React from 'react';
import styled from 'styled-components';

import { Typography as T } from 'common/typography';

import { MENU_MOBILE_BREAKPOINT } from '../../constants';

export const Root = styled.div`
  background-color: ${cbSemanticCssVars.surfaceMain};
  border-block-end: 1px solid ${cbSemanticCssVars.borderPrimary};
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  min-height: 104px;
  padding-inline: 24px;
  background-color: ${cbSemanticCssVars.surfaceMain};
  transition: background-color 100ms;
`;

export const Left = styled.div`
  display: flex;
  align-items: center;
  overflow: hidden;
  margin-inline-start: 0;
`;

export const Right = React.memo(styled.div`
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  padding-inline-start: 24px;
  @media (max-width: ${MENU_MOBILE_BREAKPOINT}px) {
    padding-inline-start: 16px;
  }
`);

export const ThumbnailContainer = styled.div`
  position: relative;
  margin-inline-end: 16px;
  @media (max-width: ${MENU_MOBILE_BREAKPOINT}px) {
    margin-inline-end: 8px;
  }
`;

export const NameAndDescription = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  white-space: nowrap;
  padding: 16px 0;
  @media (max-width: ${MENU_MOBILE_BREAKPOINT}px) {
    padding: 8px 0;
  }
`;

export const NameContainer = styled.div`
  display: flex;
  margin-block-end: 4px;
  flex-direction: row;
  align-items: center;
  @media (max-width: ${MENU_MOBILE_BREAKPOINT}px) {
    margin-block-end: 0;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
  }
`;

export const Name = styled(T.Body3).attrs({ fontWeight: 'bold' })`
  align-self: center;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${cbSemanticCssVars.textPrimary};
  @media (max-width: ${MENU_MOBILE_BREAKPOINT}px) {
    align-self: normal;
  }
`;

export const Description = styled(T.Body3)`
  color: ${cbSemanticCssVars.textSecondary};
  overflow: hidden;
  text-overflow: ellipsis;
`;
